import {
  type EntryLockOptions,
  useEntryLockController,
} from "./useEntryLockController";

const V1_OPTIONS: EntryLockOptions = {
  respectLocked24: true,
  stopEditingWhenLockedByOther: true,
  pauseKeepAliveDuringRefetchModal: true,
  releaseWhenLeavingLogbookDuringKeepAlive: true,
};

/**
 * Custom hook to manage entry locks for logbook entries (V1 generator).
 */
export const useEntryLock = () => useEntryLockController(V1_OPTIONS);
